import React from 'react';
import { Toaster } from 'react-hot-toast';
import { useTheme } from '@mui/material';

/**
 * Toast Provider with MUI theme integration
 * Provides toast notifications that match the app's Material-UI theme
 */
export const ToastProvider: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 4000,
        style: {
          background: isDark ? theme.palette.background.paper : theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[8],
          padding: '12px 16px',
          fontSize: '14px',
          fontFamily: theme.typography.fontFamily,
        },
        success: {
          iconTheme: {
            primary: theme.palette.success.main,
            secondary: theme.palette.success.contrastText,
          },
          style: {
            borderLeft: `4px solid ${theme.palette.success.main}`,
          },
        },
        error: {
          iconTheme: {
            primary: theme.palette.error.main,
            secondary: theme.palette.error.contrastText,
          },
          style: {
            borderLeft: `4px solid ${theme.palette.error.main}`,
          },
        },
        loading: {
          iconTheme: {
            primary: theme.palette.primary.main,
            secondary: theme.palette.primary.contrastText,
          },
          style: {
            borderLeft: `4px solid ${theme.palette.primary.main}`,
          },
        },
      }}
    />
  );
};
